import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {IndexedDBService} from "./indexed-db.service";
import {ShareService} from "./share.service";
import {filter, take} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class RootResolver implements Resolve<boolean> {
  constructor(
    private indexedDBService: IndexedDBService,
    private shareService: ShareService,
  ) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    console.log("resolver")
    await this.indexedDBService.isInitialized.pipe(filter(v => v === true), take(1)).toPromise();
    this.shareService.init()

    return true;
  }
}
